module.exports = "<app-multi-select-list [items]=\"items\" [(selectedItems)]=\"selectedItems\"></app-multi-select-list>"